import Model from '@/models/Model.js';

export default class InterventionMethod extends Model {
    static entity = 'intervention_method';

    static modelName = 'InterventionMethod';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            active: this.attr(null),
            icon_id: this.attr(null),
            icon: this.belongsTo('icons', 'icon_id'),
        };
    }
}
